import { z } from 'zod';

/**
 * Client-side login validation only. API / credential errors are set via RHF `setError` after submit.
 */
export const loginFormSchema = z.object({
  clinic_number: z.string().trim().min(1, '治療院IDは必須です。'),
  login_id: z.string().trim().min(1, 'ユーザーIDは必須です。'),
  password: z.string().trim().min(1, 'パスワードは必須です。'),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;
